import React, { useEffect, useState } from "react";
import AccountLayoutWeb from "./AccountLayoutWeb";
import { formatWithCommas } from "../../../Utils/Toast";
import { startCase } from "lodash";
import { apiGet } from "../../../Utils/apiFetch";
import apiPath from "../../../Utils/apiPath";
import moment from "moment";
const AccountStatement = () => {
  const [getLogData, setLogData] = useState("");
  const [search_params, setSearchParams] = useState({
    page: 1,
    limit: 50,
  });
  const myStatementData = async () => {
    const { status, data: response_users } = await apiGet(
      apiPath.transactionTxnLogs,
      search_params
    );
    if (status === 200) {
      if (response_users.success) {
        setLogData(response_users.results);
      }
    }
  };
  useEffect(() => {
    myStatementData();
  }, [search_params]);
  return (
    <AccountLayoutWeb>
      <div className="col-center report">
        <h2>Account Statement</h2>{" "}
        <table className="table-s" id="Matched_Table">
          <tbody>
            <tr>
              <th scope="col" className="text-left">
                Date/Time
              </th>
              <th scope="col" className="text-end">
                Deposit
              </th>
              <th scope="col" className="text-end">
                WithDraw
              </th>
              <th scope="col" className="text-end">
                Balance
              </th>
              <th scope="col" className="text-end">
                Remark
              </th>
              <th scope="col" className="text-end">
                From/To
              </th>
            </tr>
          </tbody>

          {getLogData.data?.length > 0 ? (
            <tbody id="Matched_Content">
              {getLogData.data &&
                getLogData.data.map((item, key) => (
                  <tr>
                    <td>
                      {moment(item?.createdAt).format("YYYY-MM-DD hh:mm:ss")}
                    </td>
                    <td>
                      {item?.transactionType === "credit" ? (
                        <span className="">
                          {formatWithCommas(item?.amount)}
                        </span>
                      ) : (
                        "-"
                      )}
                    </td>
                    <td>
                      {" "}
                      {item?.transactionType === "debit" ? (
                        <span className="text-danger">
                          {"(" + formatWithCommas(item?.amount) + ")"}
                        </span>
                      ) : (
                        "-"
                      )}
                    </td>

                    <td>{formatWithCommas(item?.newBalance)}</td>
                    <td width={"26%"}>{item?.remark || ""}</td>

                    <td style={{ textAlign: "right" }}>
                      {startCase(item?.createdByData?.userType)}{" "}
                      <img
                        class="fromto"
                        src={require("../../../assets/images/transparent.gif")}
                      />
                      {item?.userData?.username}
                    </td>
                  </tr>
                ))}
            </tbody>
          ) : (
            <tbody id="Matched_Content">
              <tr
                id="noDataTemplate"
                style={{
                  display: "table-row",
                }}
              >
                <td className="no-data" colSpan="9">
                  <p>You have no bets in this time period.</p>
                </td>
              </tr>
            </tbody>
          )}
        </table>
      </div>
    </AccountLayoutWeb>
  );
};

export default AccountStatement;
